import React from 'react';
import PropTypes from 'prop-types';
import { includes, isArray, map } from 'lodash';
import classNames from 'classnames';
import { BasicForm } from './BasicForm.jsx';
import { FormLabel } from '../FormLabel.jsx';
import { FormErrorMessage } from '../FormErrorMessage.jsx';
import * as textUtil from '../../../../../../utils/textUtil';

export class MultipleChoiceForm extends BasicForm {

  getLabelUtilText(object, input) {
    const { systemMessages } = this.props;
    const { data: { mode } } = object;

    return mode === 'selection'
      ? textUtil.replaceNumber(systemMessages.selectedQuantity, input.value.length)
      : '';
  }

  handleClick(e, label) {
    e.preventDefault();
    const { input, object: { data: { mode } } } = this.props;
    const value = this.handleMultipleChoice(mode, input, label)
    input.onBlur();
    input.onChange(value);
  }

  handleMultipleChoice(mode, input, value) {
    switch (mode) {
      case 'toggle':
        return input.value === value
          ? ''
          : value;
      case 'selection':
        const selections = input.value;
        return includes(selections, value)
          ? selections.filter(d => d !== value)
          : selections.concat([value]);
    }
  }

  isSelectedMultipleChoice(mode, input, value) {
    switch (mode) {
      case 'toggle':
        return input.value === value;
      case 'selection':
        return isArray(input.value) && includes(input.value, value);
    }
  }

  handleInitialSelect(input, candidate) {
    input.onChange(candidate);
  }

  componentDidMount() {
    const { input, object: { data: { mode, initial_value } } } = this.props;
  }

  render() {
    const { disabled, input, meta, object: { label, validations, data: { mode, candidates } } } = this.props;

    return (
      <div className="cu-ui-form-group">
        <FormLabel
          valid={meta.valid}
          label={label}
          required={validations.required}
          utilText={this.getLabelUtilText(this.props.object, input)}
        />
        <div className="cu-ui-button-group">
          {map(candidates, (button, idx) => {
            const buttonClassName = classNames('cu-ui-button', 'check-box', {
              'cu-ui-primary': this.isSelectedMultipleChoice(mode, input, button.value),
              'check-box-selected': this.isSelectedMultipleChoice(mode, input, button.value)
            });

            return (
              <button
                key={idx}
                className={buttonClassName}
                disabled={disabled}
                onClick={e => this.handleClick(e, button.value)}
              >
                {button.label}
              </button>
            );
          })}
        </div>
        <FormErrorMessage
          error={meta.error}
          touched={meta.touched}
        />
      </div>
    );
  }
}
